const wowApp = require('angular').module('wowApp.common');

//Service
wowApp.service('ListProductService', [require('./listproducts-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/lists/index.js
 **/